import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
})

instance.defaults.headers.common.Authorization = `Bearer ${localStorage.token}`

// Login e logout tratam o 401 por conta própria
const ROTAS_AUTENTICACAO = /\/?api\/(login|logout)\/?$/

let sessaoEncerrada = false

instance.interceptors.response.use(response => response, error => {
  const status = error.response?.status
  const url = error.config?.url || ''
  if (status === 401 && !ROTAS_AUTENTICACAO.test(url) && localStorage.getItem('token') && !sessaoEncerrada) {
    sessaoEncerrada = true
    localStorage.clear()
    sessionStorage.setItem('avisoLogin', 'Sua sessão expirou, entre novamente.')
    // Recarrega a aplicação para descartar o token antigo dos headers padrão
    window.location.replace(process.env.BASE_URL || '/')
  }
  return Promise.reject(error)
})

export default instance
